import type { NavigationGuard } from "vue-router";

import { useSearchStore } from "@/stores";

export function resetSearchStoreGuard(): NavigationGuard {
  return () => {
    const searchStore = useSearchStore();

    searchStore.reset();
  };
}
